import React from 'react';

import { InputField } from 'vindi-ds-components';
import TwoColmunsFieldsRow from '../TwoColmunsFieldsRow';
import CustomerAddressField from './CustomerAddressField';
import CustomerCityField from './CustomerCityField';
import CustomerComplementField from './CustomerComplementField';
import CustomerNeighborhoodField from './CustomerNeighborhoodField';

function CustomerAddressFields() {
  return (
    <>
      <CustomerAddressField />
      <TwoColmunsFieldsRow
        gridTemplateColumns={{ md: '1fr', lg: '1fr 3fr' }}
      >
        <InputField label='Número' name='number' type='number' min='0' />
        <CustomerComplementField />
      </TwoColmunsFieldsRow>
      <TwoColmunsFieldsRow gridTemplateColumns={{ md: '1fr', lg: '1fr 1fr' }}>
        <CustomerNeighborhoodField />
        <CustomerCityField />
      </TwoColmunsFieldsRow>
    </>
  );
}

export default CustomerAddressFields;
